export default {"src":"/_next/static/media/goal-playing.dcd3243f.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};